/* CLB XXIII - Product page recommendations
   ---------------------------------------------------------------------------
   <clb-recs> fills three carousels (Complete the Look, Similar Pieces, Recently
   Viewed) and the sold-out "Available now" panel. Cards are rendered by
   sections/clb-recs-feed.liquid through the Section Rendering API, using the
   storefront search (product_type / vendor / tag), so there is no API token.

   Motion follows Apple's fluid-interface rules: 1:1 drag with a hysteresis
   threshold, springs described by damping ratio + response, release velocity
   handed to the spring, momentum projection to pick the resting card,
   rubber-banding at the edges, and every animation interruptible. The glass
   behind each carousel takes on the colour of the product in front.
*/
(function () {
  'use strict';
  if (window.customElements.get('clb-recs')) return;

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var RV_KEY = 'clb:recently-viewed';

  /* ---------------- physics ---------------- */
  function Spring(onFrame) { this.x = 0; this.v = 0; this.raf = 0; this.onFrame = onFrame; }
  Spring.prototype.stop = function () { if (this.raf) cancelAnimationFrame(this.raf); this.raf = 0; };
  Spring.prototype.to = function (target, o) {
    o = o || {};
    this.stop();
    if (o.velocity !== undefined) this.v = o.velocity;
    var z = o.damping !== undefined ? o.damping : 1;
    var r = o.response !== undefined ? o.response : 0.4;
    var k = Math.pow(2 * Math.PI / r, 2), c = 4 * Math.PI * z / r;
    var last = performance.now(), self = this;
    function tick(now) {
      var dt = Math.min(0.064, (now - last) / 1000); last = now;
      var n = 4, h = dt / n;
      for (var i = 0; i < n; i++) { var a = -k * (self.x - target) - c * self.v; self.v += a * h; self.x += self.v * h; }
      if (Math.abs(self.x - target) < 0.05 && Math.abs(self.v) < 2) { self.x = target; self.v = 0; self.onFrame(self.x); self.raf = 0; return; }
      self.onFrame(self.x);
      self.raf = requestAnimationFrame(tick);
    }
    this.raf = requestAnimationFrame(tick);
  };
  function project(v, d) { return (v / 1000) * d / (1 - d); }
  function rubber(o, dim) { return (o * dim * 0.55) / (dim + 0.55 * Math.abs(o)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* ---------------- product colour -> glass tint ---------------- */
  var TINTS = {
    black: [160, 168, 182], white: [222, 214, 200], cream: [226, 212, 186], ivory: [226, 216, 196],
    gray: [184, 188, 196], grey: [184, 188, 196], silver: [196, 202, 212], charcoal: [150, 156, 168],
    red: [251, 106, 119], burgundy: [196, 96, 116], maroon: [196, 96, 116], pink: [246, 160, 190],
    orange: [248, 168, 110], yellow: [240, 208, 110], gold: [222, 190, 120],
    green: [130, 196, 150], olive: [176, 184, 120], teal: [110, 196, 196],
    blue: [127, 152, 230], navy: [120, 140, 210], purple: [178, 150, 230],
    brown: [196, 160, 128], tan: [214, 190, 150], beige: [220, 200, 166], khaki: [206, 190, 146],
    multicolor: [206, 170, 226], camo: [176, 176, 132]
  };
  var NEUTRAL = [176, 182, 194];
  var ACHROMATIC = { black: 1, white: 1, gray: 1, grey: 1, silver: 1, charcoal: 1, cream: 1, ivory: 1 };
  function tintFor(str) {
    var list = String(str || '').toLowerCase().split(/\s*[,\/|]\s*/).filter(Boolean);
    function key(c) { if (TINTS[c]) return c; for (var k in TINTS) if (c.indexOf(k) > -1) return k; return null; }
    var keys = list.map(key).filter(Boolean);
    for (var i = 0; i < keys.length; i++) if (!ACHROMATIC[keys[i]]) return TINTS[keys[i]];
    return keys.length ? TINTS[keys[0]] : NEUTRAL;
  }
  function mix(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t]; }
  function rgb(c) { return 'rgb(' + Math.round(c[0]) + ',' + Math.round(c[1]) + ',' + Math.round(c[2]) + ')'; }

  /* ---------------- feeds ---------------- */
  var cache = new Map();
  function feed(url) {
    if (!cache.has(url)) {
      cache.set(url, fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return Array.prototype.slice.call(doc.querySelectorAll('[data-rec]'));
        })
        .catch(function () { return []; }));
    }
    return cache.get(url);
  }
  function qv(s) { return '"' + String(s).replace(/"/g, '') + '"'; }
  function searchUrl(query) {
    return ROOT + 'search?q=' + encodeURIComponent(query) +
      '&type=product&options%5Bunavailable_products%5D=hide&options%5Bprefix%5D=none&section_id=clb-recs-feed';
  }
  function typesQuery(types) { return '(' + types.map(function (t) { return 'product_type:' + qv(t); }).join(' OR ') + ')'; }
  function meta(el) {
    return {
      el: el, id: el.getAttribute('data-id'), type: el.getAttribute('data-type') || '',
      vendor: el.getAttribute('data-vendor') || '', price: parseInt(el.getAttribute('data-price'), 10) || 0,
      stale: el.hasAttribute('data-stale'), boost: el.hasAttribute('data-boost'), source: el.getAttribute('data-source') || ''
    };
  }

  /* category labels for the filter */
  var GROUP = { 'Jackets': 'Outerwear', 'Coats': 'Outerwear', 'Vests': 'Outerwear', 'Hoodies & Sweatshirts': 'Hoodies',
    'Wallets & Cardholders': 'Wallets', 'Belts & Buckles': 'Belts', 'Scarves & Gloves': 'Scarves & Gloves',
    'Cleaning Supplies': 'Care', 'Crease Protectors': 'Care', 'Shoe Laces': 'Care', 'Active Pants': 'Sweatpants' };
  function groupOf(type) { return GROUP[type] || type || 'More'; }

  /* ---------------- rail ---------------- */
  function Rail(block, opts) {
    var R = this;
    R.block = block;
    R.vp = block.querySelector('[data-viewport]');
    R.el = block.querySelector('[data-track]');
    R.thumb = block.querySelector('[data-thumb]');
    R.meter = R.thumb ? R.thumb.parentNode : null;
    R.aura = block.querySelector('.clbr-aura');
    R.prev = block.querySelector('[data-prev]');
    R.next = block.querySelector('[data-next]');
    R.parallax = !!(opts && opts.parallax) && !RM;
    R.sp = new Spring(function (x) { R.paint(x); });
    R.pressed = false; R.dragging = false; R.justDragged = false; R.hist = [];

    R.vp.addEventListener('pointerdown', function (e) { R.down(e); });
    R.vp.addEventListener('pointermove', function (e) { R.move(e); });
    R.vp.addEventListener('pointerup', function (e) { R.up(e); });
    R.vp.addEventListener('pointercancel', function (e) { R.up(e); });
    R.vp.addEventListener('click', function (e) { if (R.justDragged) { e.preventDefault(); e.stopPropagation(); } }, true);
    R.vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
    R.vp.addEventListener('wheel', function (e) { R.wheel(e); }, { passive: false });
    R.vp.addEventListener('keydown', function (e) {
      if (e.target !== R.vp) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); R.go(1, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); R.go(-1, true); }
    });
    R.vp.addEventListener('focusin', function (e) { R.reveal(e.target); });
    if (R.prev) R.prev.addEventListener('click', function () { R.go(-1); });
    if (R.next) R.next.addEventListener('click', function () { R.go(1); });
    if ('ResizeObserver' in window) {
      R.ro = new ResizeObserver(function () { R.measure(); R.sp.stop(); R.sp.x = clamp(R.sp.x, R.min, 0); R.paint(R.sp.x); });
      R.ro.observe(R.vp);
    }
    R.measure(); R.paint(0);
  }
  Rail.prototype.cards = function () {
    return Array.prototype.filter.call(this.el.children, function (n) { return !n.hidden; });
  };
  Rail.prototype.measure = function () {
    var c = this.cards(), f = c[0], s = c[1];
    this.vw = this.vp.clientWidth || 390;
    this.cardW = f ? f.offsetWidth : 200;
    this.pad = f ? f.offsetLeft : 0;
    this.step = (f && s) ? (s.offsetLeft - f.offsetLeft) : this.cardW + 12;
    this.min = Math.min(0, this.vw - this.el.scrollWidth);
    this.tints = c.map(function (n) { return n._tint || NEUTRAL; });
    this.imgs = c.map(function (n) { return n.querySelector('.clbr-card__img'); });
    this.lefts = c.map(function (n) { return n.offsetLeft; });
    if (this.meter) this.meter.hidden = this.min >= 0;
  };
  Rail.prototype.paint = function (x) {
    this.el.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
    var i;
    if (this.parallax) {
      for (i = 0; i < this.imgs.length; i++) {
        var img = this.imgs[i]; if (!img) continue;
        var rel = (this.lefts[i] + x) / this.vw;
        img.style.transform = 'translate3d(' + (-rel * 16).toFixed(2) + 'px,0,0) scale(1.12)';
      }
    }
    var n = this.tints.length;
    if (n) {
      var f = clamp((this.vw / 2 - this.pad - this.cardW / 2 - x) / this.step, 0, n - 1);
      i = Math.floor(f);
      var t = f - i;
      var c0 = this.tints[i], c1 = this.tints[Math.min(n - 1, i + 1)], c2 = this.tints[Math.min(n - 1, i + 2)];
      var main = mix(c0, c1, t), next = mix(c1, c2, t);
      if (this.aura && this.aura.children.length > 1) {
        var b0 = this.aura.children[0], b1 = this.aura.children[1];
        b0.style.backgroundColor = rgb(main); b1.style.backgroundColor = rgb(next);
        if (!RM) {
          b0.style.transform = 'translate3d(' + (-t * 36).toFixed(1) + 'px,' + (Math.sin(t * Math.PI) * 10).toFixed(1) + 'px,0)';
          b1.style.transform = 'translate3d(' + ((1 - t) * 36).toFixed(1) + 'px,0,0)';
        }
      }
      if (this.thumb) this.thumb.style.backgroundColor = rgb(mix(main, [28, 28, 28], 0.6));
    }
    if (this.thumb) {
      var p = this.min < 0 ? x / this.min : 0;
      this.thumb.style.transform = 'translate3d(' + (clamp(p, -0.12, 1.12) * 40).toFixed(2) + 'px,0,0)';
    }
    if (this.prev) this.prev.disabled = x >= -1;
    if (this.next) this.next.disabled = x <= this.min + 1;
  };
  Rail.prototype.nearest = function (p) {
    var best = 0, bd = Infinity, n = this.lefts.length;
    for (var i = 0; i < n; i++) {
      var s = clamp(-(this.lefts[i] - this.pad), this.min, 0);
      var d = Math.abs(s - p); if (d < bd) { bd = d; best = s; }
    }
    if (Math.abs(this.min - p) < bd) best = this.min;
    return best;
  };
  Rail.prototype.go = function (dir, single) {
    var per = single ? 1 : Math.max(1, Math.floor((this.vw - this.pad) / this.step));
    var i = Math.round(-this.sp.x / this.step) + dir * per;
    this.sp.to(clamp(-i * this.step, this.min, 0), { damping: 1, response: RM ? 0.25 : 0.5 });
  };
  Rail.prototype.reveal = function (target) {
    var card = target.closest && target.closest('.clbr-card');
    if (!card || !this.el.contains(card)) return;
    var left = card.offsetLeft + this.sp.x;
    if (left < this.pad || left + card.offsetWidth > this.vw - this.pad) {
      this.sp.to(clamp(-(card.offsetLeft - this.pad), this.min, 0), { damping: 1, response: 0.4 });
    }
  };
  Rail.prototype.down = function (e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    this.sp.stop();                              // grab from the live value
    this.pressed = true; this.dragging = false;
    this.sx = e.clientX; this.sy = e.clientY; this.x0 = this.sp.x;
    this.hist = [[e.timeStamp, e.clientX]];
  };
  Rail.prototype.move = function (e) {
    if (!this.pressed) return;
    var dx = e.clientX - this.sx, dy = e.clientY - this.sy;
    if (!this.dragging) {
      if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) { this.pressed = false; return; }
      if (Math.abs(dx) < 8) return;              // hysteresis before committing
      this.dragging = true; this.sx = e.clientX; this.x0 = this.sp.x;
      try { this.vp.setPointerCapture(e.pointerId); } catch (err) {}
      this.vp.classList.add('is-drag');
    }
    var raw = this.x0 + (e.clientX - this.sx);
    if (raw > 0) raw = rubber(raw, this.vw); else if (raw < this.min) raw = this.min - rubber(this.min - raw, this.vw);
    this.sp.x = raw; this.sp.v = 0; this.paint(raw);
    this.hist.push([e.timeStamp, e.clientX]);
    while (this.hist.length > 2 && e.timeStamp - this.hist[0][0] > 100) this.hist.shift();
  };
  Rail.prototype.up = function (e) {
    if (!this.pressed && !this.dragging) return;
    this.pressed = false;
    if (!this.dragging) return;
    this.dragging = false;
    this.vp.classList.remove('is-drag');
    var self = this;
    this.justDragged = true; setTimeout(function () { self.justDragged = false; }, 0);
    var a = this.hist[0], b = this.hist[this.hist.length - 1], v = 0;
    if (b[0] - a[0] > 0 && e.timeStamp - b[0] < 80) v = (b[1] - a[1]) / (b[0] - a[0]) * 1000;
    v = clamp(v, -4000, 4000);
    var target = this.nearest(this.sp.x + project(v, 0.995));
    var flick = Math.abs(v) > 350;
    this.sp.to(target, { velocity: v, damping: RM ? 1 : (flick ? 0.84 : 1), response: RM ? 0.25 : 0.42 });
  };
  Rail.prototype.wheel = function (e) {
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    e.preventDefault();
    this.sp.stop();
    var x = clamp(this.sp.x - e.deltaX, this.min - 48, 48);
    this.sp.x = x; this.sp.v = 0; this.paint(x);
    var self = this;
    clearTimeout(this.wt);
    this.wt = setTimeout(function () { self.sp.to(self.nearest(self.sp.x), { damping: 1, response: 0.45 }); }, 120);
  };
  Rail.prototype.reset = function () {
    this.sp.stop(); this.sp.x = 0; this.sp.v = 0; this.measure(); this.paint(0);
  };

  /* ---------------- segmented control ---------------- */
  function Seg(root, labels, onPick) {
    var S = this;
    S.root = root; S.lens = root.querySelector('[data-lens]'); S.btns = []; S.sel = 0;
    S.lx = new Spring(function () { S.paint(); }); S.lw = new Spring(function () { S.paint(); });
    labels.forEach(function (label, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'clbr-segbtn'; b.textContent = label;
      b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      b.addEventListener('click', function () {
        if (S.sel === i) return;
        S.btns[S.sel].setAttribute('aria-pressed', 'false');
        b.setAttribute('aria-pressed', 'true');
        S.sel = i; S.place(true); onPick(label, i);
      });
      root.appendChild(b); S.btns.push(b);
    });
    root.hidden = false;
    S.place(false);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { S.place(false); });
  }
  Seg.prototype.paint = function () {
    var stretch = RM ? 0 : Math.min(0.22, Math.abs(this.lx.v) / 3200);
    this.lens.style.width = this.lw.x.toFixed(2) + 'px';
    this.lens.style.transform = 'translate3d(' + this.lx.x.toFixed(2) + 'px,0,0) scale(' + (1 + stretch).toFixed(3) + ',' + (1 - stretch * 0.35).toFixed(3) + ')';
  };
  Seg.prototype.place = function (animate) {
    var b = this.btns[this.sel]; if (!b) return;
    if (!animate || RM) { this.lx.stop(); this.lw.stop(); this.lx.x = b.offsetLeft; this.lw.x = b.offsetWidth; this.lx.v = 0; this.paint(); return; }
    this.lx.to(b.offsetLeft, { damping: 0.82, response: 0.38 });
    this.lw.to(b.offsetWidth, { damping: 1, response: 0.34 });
  };

  /* materialise: blur + scale + fade, staggered */
  function materialise(nodes) {
    if (RM) return;
    nodes.forEach(function (n, i) {
      if (!n.animate || i > 6) return;
      n.animate(
        [{ opacity: 0, transform: 'translate3d(28px,0,0) scale(.96)', filter: 'blur(8px)' },
         { opacity: 1, transform: 'none', filter: 'blur(0px)' }],
        { duration: 560, delay: i * 45, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' }
      );
    });
  }

  /* ---------------- element ---------------- */
  class ClbRecs extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try { this.cfg = JSON.parse(this.querySelector('[data-clbr-config]').textContent); } catch (e) { return; }
      this.rails = {};
      this.readRecent();
      this.bindAdd();

      var soldPanel = this.cfg.show.soldout && !this.cfg.available ? this.mountSoldOut() : null;
      if (soldPanel) this.loadSimilar(soldPanel);   // above the fold: load at once

      var self = this;
      var start = function () { self.load(); };
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          if (entries.some(function (en) { return en.isIntersecting; })) { self.io.disconnect(); start(); }
        }, { rootMargin: '900px 0px' });
        this.io.observe(this);
      } else { start(); }
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }

    load() {
      if (this.cfg.show.look) this.loadLook();
      if (this.cfg.show.similar) this.loadSimilar();
      if (this.cfg.show.recent) this.loadRecent();
    }

    block(name) { return this.querySelector('[data-block="' + name + '"]'); }
    picks(name) {
      var t = this.querySelector('template[data-picks="' + name + '"]');
      return t ? Array.prototype.slice.call(t.content.querySelectorAll('[data-rec]')) : [];
    }
    skeleton(name, count) {
      var b = this.block(name); if (!b) return;
      var track = b.querySelector('[data-track]');
      if (track.children.length) return;
      for (var i = 0; i < count; i++) { var s = document.createElement('div'); s.className = 'clbr-skel'; s.setAttribute('aria-hidden', 'true'); track.appendChild(s); }
      b.hidden = false;
    }
    prepare(item) {
      var node = document.importNode(item.el, true);
      var chip = node.querySelector('[data-chip]');
      if (chip && item.why) {
        chip.textContent = item.why; chip.hidden = false;
        if (item.pick) chip.classList.add('clbr-chip--pick');
      }
      var tint = tintFor(node.getAttribute('data-color'));
      node._tint = tint;
      node.style.setProperty('--clbr-glow', 'rgba(' + tint.map(Math.round).join(',') + ',.95)');
      return node;
    }
    render(name, items, opts) {
      var b = this.block(name); if (!b) return [];
      var track = b.querySelector('[data-track]');
      if (!items.length) { track.replaceChildren(); b.hidden = true; return []; }
      var self = this;
      var nodes = items.map(function (it) { return self.prepare(it); });
      track.replaceChildren.apply(track, nodes);
      b.hidden = false;
      if (!this.rails[name]) this.rails[name] = new Rail(b, opts);
      else this.rails[name].reset();
      this.rails[name].measure(); this.rails[name].paint(0);
      materialise(nodes);
      return nodes;
    }

    /* ----- Complete the Look ----- */
    loadLook() {
      var cfg = this.cfg, self = this, lim = cfg.limits.look;
      var targets = cfg.targets || [];
      var push = (cfg.season && cfg.season.push) || [];
      var seasonName = cfg.season ? cfg.season.name : '';
      this.skeleton('look', 3);

      var jobs = [];
      jobs.push(cfg.preferBrand && targets.length && cfg.vendor ? feed(searchUrl('vendor:' + qv(cfg.vendor) + ' AND ' + typesQuery(targets))) : Promise.resolve([]));
      jobs.push(targets.length ? feed(searchUrl('tag:"rec-boost" AND ' + typesQuery(targets))) : Promise.resolve([]));
      jobs.push(cfg.staleSlot && targets.length ? feed(searchUrl('tag:"Stale-Tier-4" AND ' + typesQuery(targets))) : Promise.resolve([]));
      targets.forEach(function (t) { jobs.push(feed(searchUrl('product_type:' + qv(t)))); });

      Promise.all(jobs).then(function (res) {
        var brand = res[0].map(meta), boost = res[1].map(meta), stale = res[2].map(meta);
        var byType = res.slice(3).map(function (list) { return list.map(meta); });
        var seen = {}; seen[String(cfg.productId)] = 1;
        var out = [];
        function label(m) {
          if (m.boost) return 'Trending';
          if (cfg.vendor && m.vendor === cfg.vendor) return 'Same maker';
          if (seasonName && push.indexOf(m.type) > -1) return seasonName;
          return 'Pairs well';
        }
        function add(m, why, pick) {
          if (!m || seen[m.id] || out.length >= lim) return false;
          if (!pick && targets.indexOf(m.type) < 0) return false;
          seen[m.id] = 1; out.push({ el: m.el, why: why, pick: !!pick, type: m.type }); return true;
        }

        self.picks('look').map(meta).forEach(function (m) { add(m, 'Staff pick', true); });
        boost.forEach(function (m) { add(m, label(m)); });

        // one queue per target: same brand first, then everything else
        var queues = targets.map(function (t, i) {
          return brand.filter(function (m) { return m.type === t; }).concat(byType[i] || []);
        });
        var staleItem = stale.filter(function (m) { return !seen[m.id]; })[0];
        var staleAt = Math.min(4, lim - 1);
        var guard = 0;
        while (out.length < lim && guard++ < 200) {
          var moved = false;
          for (var q = 0; q < queues.length && out.length < lim; q++) {
            if (staleItem && out.length === staleAt) { add(staleItem, label(staleItem)); staleItem = null; }
            while (queues[q].length) { var m = queues[q].shift(); if (add(m, label(m))) { moved = true; break; } }
          }
          if (!moved) break;
        }
        if (staleItem && out.length < lim) add(staleItem, label(staleItem));

        var finish = function () {
          var nodes = self.render('look', out, { parallax: true });
          self.buildFilter(out, nodes);
        };
        if (out.length < 4 && cfg.fallback) {
          feed(ROOT + 'collections/' + encodeURIComponent(cfg.fallback) + '?section_id=clb-recs-feed').then(function (list) {
            list.map(meta).forEach(function (m) {
              if (m && !seen[m.id] && out.length < lim) { seen[m.id] = 1; out.push({ el: m.el, why: 'Trending', type: m.type }); }
            });
            finish();
          });
        } else finish();
      });
    }

    buildFilter(items, nodes) {
      var b = this.block('look'); if (!b) return;
      var segEl = b.querySelector('[data-seg]'); if (!segEl || this.seg) return;
      var groups = [];
      items.forEach(function (it) { var g = groupOf(it.type); if (groups.indexOf(g) < 0 && !it.pick) groups.push(g); });
      if (groups.length < 2) return;
      var self = this;
      nodes.forEach(function (n, i) { n._group = items[i].pick ? '*' : groupOf(items[i].type); });
      this.seg = new Seg(segEl, ['All'].concat(groups.slice(0, 5)), function (label) {
        var shown = [];
        nodes.forEach(function (n) {
          var on = label === 'All' || n._group === label || n._group === '*';
          n.hidden = !on; if (on) shown.push(n);
        });
        self.rails.look.reset();
        materialise(shown);
      });
    }

    /* ----- Similar Pieces (+ sold-out panel) ----- */
    loadSimilar(soldPanel) {
      if (this._similar) { if (soldPanel) this._similar.then(this.fillSoldOut.bind(this, soldPanel)); return; }
      var cfg = this.cfg, self = this, lim = cfg.limits.similar;
      if (!soldPanel) this.skeleton('similar', 3);
      var jobs = [
        cfg.type && cfg.vendor ? feed(searchUrl('product_type:' + qv(cfg.type) + ' AND vendor:' + qv(cfg.vendor))) : Promise.resolve([]),
        cfg.type ? feed(searchUrl('product_type:' + qv(cfg.type))) : Promise.resolve([])
      ];
      this._similar = Promise.all(jobs).then(function (res) {
        var seen = {}; seen[String(cfg.productId)] = 1;
        var out = [], price = cfg.price || 0, band = cfg.priceBand || 0.4;
        function near(m) { return price > 0 && Math.abs(m.price - price) / price <= 0.2; }
        function add(m, why, pick) {
          if (!m || seen[m.id] || out.length >= lim) return;
          seen[m.id] = 1; out.push({ el: m.el, why: why, pick: !!pick, meta: m });
        }
        self.picks('similar').map(meta).forEach(function (m) { add(m, 'Staff pick', true); });
        var sameBrand = res[0].map(meta).filter(function (m) { return m.type === cfg.type; });
        sameBrand.sort(function (a, b) { return Math.abs(a.price - price) - Math.abs(b.price - price); });
        sameBrand.forEach(function (m) { add(m, near(m) ? 'Same price' : 'Same maker'); });
        var others = res[1].map(meta).filter(function (m) {
          return m.type === cfg.type && (price <= 0 || Math.abs(m.price - price) / price <= band);
        });
        others.sort(function (a, b) { return Math.abs(a.price - price) - Math.abs(b.price - price); });
        others.forEach(function (m) { add(m, 'Similar price'); });
        if (out.length >= 4) return out;
        return feed(ROOT + 'recommendations/products?product_id=' + cfg.productId + '&limit=10&intent=related&section_id=clb-recs-feed')
          .then(function (list) { list.map(meta).forEach(function (m) { add(m, 'Also consider'); }); return out; });
      });
      this._similar.then(function (out) {
        if (cfg.show.similar) self.render('similar', out);
        if (soldPanel) self.fillSoldOut(soldPanel, out);
      });
    }

    fillSoldOut(panel, out) {
      if (panel._filled) return;
      var list = panel.querySelector('[data-list]'); if (!list || !out || !out.length) return;
      panel._filled = true;
      var tints = [];
      out.slice(0, 3).forEach(function (it) {
        var el = it.el;
        var info = el.querySelector('.clbr-card__info');
        var img = el.querySelector('.clbr-card__img');
        var a = document.createElement('a');
        a.className = 'clbr-alt'; a.href = info ? info.getAttribute('href') : '#';
        if (img) {
          var im = document.createElement('img');
          im.src = img.getAttribute('src'); im.alt = ''; im.loading = 'lazy'; im.width = 64; im.height = 80;
          a.appendChild(im);
        }
        var txt = document.createElement('span'); txt.className = 'clbr-alt__txt';
        [['clbr-alt__v', '.clbr-card__vendor'], ['clbr-alt__t', '.clbr-card__title'], ['clbr-alt__p', '.clbr-card__price']].forEach(function (p) {
          var s = document.createElement('span'); s.className = p[0];
          var src = el.querySelector(p[1]); s.innerHTML = src ? src.innerHTML : '';
          txt.appendChild(s);
        });
        a.appendChild(txt);
        a.insertAdjacentHTML('beforeend', '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>');
        list.appendChild(a);
        tints.push(tintFor(el.getAttribute('data-color')));
      });
      var aura = panel.querySelector('.clbr-aura');
      if (aura) aura.querySelectorAll('span').forEach(function (s, i) { s.style.backgroundColor = rgb(tints[i % tints.length] || NEUTRAL); });
      panel.hidden = false;
    }

    /* Sold out: place "Available now" + "Have us source one" in the buy box,
       just above the returns line of the CLB product section. */
    mountSoldOut() {
      var pdp = document.querySelector('.clb-custom-pdp');
      if (!pdp || pdp.querySelector('[data-clbr-soldout]')) return null;
      var anchor = pdp.querySelector('.return-policy');
      var wrap = document.createElement('div');
      wrap.innerHTML =
        '<div class="clbr-soldout" data-clbr-soldout hidden>' +
          '<div class="clbr-aura" aria-hidden="true"><span></span><span></span></div>' +
          '<div class="clbr-soldout__inner clbr-glass-thick">' +
            '<div class="clbr-soldout__head"><span>Available now</span><span>Ships within 24 hours</span></div>' +
            '<div data-list style="display:flex;flex-direction:column;gap:10px"></div>' +
            '<a class="clbr-soldout__all" href="#clb-similar">See all similar pieces</a>' +
          '</div>' +
        '</div>' +
        '<a class="clbr-source" href="mailto:clientservices@clb23.com?subject=' + encodeURIComponent('Source request: ' + (this.cfg.title || '')) + '">Have us source one for you</a>' +
        '<p class="clbr-source-note">Our Private Client team will look for this piece and reach out, with no obligation.</p>';
      var nodes = Array.prototype.slice.call(wrap.childNodes);
      nodes.forEach(function (n) {
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(n, anchor);
        else pdp.appendChild(n);
      });
      return nodes[0];
    }

    /* ----- Recently Viewed ----- */
    readRecent() {
      var list = [];
      try { list = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { list = []; }
      if (!Array.isArray(list)) list = [];
      var id = String(this.cfg.productId);
      this.recentIds = list.filter(function (x) { return String(x) !== id; });
      try { localStorage.setItem(RV_KEY, JSON.stringify([id].concat(this.recentIds).slice(0, 24))); } catch (e) {}
    }
    loadRecent() {
      var ids = (this.recentIds || []).slice(0, this.cfg.limits.recent), self = this;
      if (!ids.length) return;
      feed(searchUrl(ids.map(function (i) { return 'id:' + i; }).join(' OR '))).then(function (list) {
        var byId = {};
        list.map(meta).forEach(function (m) { byId[m.id] = m; });
        var out = ids.map(function (i) { return byId[String(i)]; }).filter(Boolean).map(function (m) { return { el: m.el }; });
        self.render('recent', out);
      });
    }

    /* ----- quick add ----- */
    bindAdd() {
      this.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-add]');
        if (!b) return;
        e.preventDefault();
        var drawer = document.querySelector('cart-drawer, #cart-drawer');
        var hasDrawer = drawer && typeof drawer.show === 'function';
        if (b.classList.contains('is-added')) { if (hasDrawer) drawer.show(); else window.location.href = ROOT + 'cart'; return; }
        b.classList.add('is-busy');
        fetch(ROOT + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-add'), 10), quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            b.classList.remove('is-busy'); b.classList.add('is-added');
            b.setAttribute('aria-label', 'Added to cart. Tap again to view your cart');
            var sr = document.getElementById('status-announcement'); if (sr) sr.textContent = 'Added to cart';
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            if (hasDrawer) drawer.show();
          })
          .catch(function () {
            b.classList.remove('is-busy');
            var card = b.closest('.clbr-card'), link = card && card.querySelector('.clbr-card__info');
            if (link) window.location.href = link.getAttribute('href');
          });
      });
    }
  }

  window.customElements.define('clb-recs', ClbRecs);
})();
